module.exports = __webpack_public_path__ + "media/gomenn.f1273779.mp3";